<template>
  <v-dialog
    v-model="show"
    width="400px"
    @opened="dialogOpened">
    <div class="dialog-container">
      <div class="dialog-header">
        <p>Subscribe QR Code</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="changeDialog"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <div
          ref="qrcode"
          class="qrcode"></div>

        <div class="info">
          <div class="link">{{codeUrl}}</div>
          <v-button
            gray
            class="blue"
            @click="handleCopy">Copy</v-button>
        </div>

        <div class="btn-list">
          <v-button
            gray
            class="red"
            @click="disableCode">Disable QR Code Now</v-button>
          <v-button
            green
            @click="changeDialog">OK</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  name: '',
  props:{
    codeUrl: {
      type: String,
      default: ''
    },
    codeID: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      show: false,
      qrcode: null
    }
  },
  methods: {
    changeDialog(){
      this.show = !this.show
    },
    disableCode(){
      this.$emit('disableCode', this.codeID)
    },
    dialogOpened(){
      if(this.qrcode){
        // 清除上一个二维码的缓存
        this.qrcode.clear()
        this.$refs.qrcode.innerHTML = ''
      }
      if(this.codeUrl){
        this.qrcode = new QRCode(this.$refs.qrcode,{
          text: this.codeUrl,
          width: 220,
          height: 220
        })
      }
    },
    handleCopy(){
      let textareaElement = document.createElement('textarea')
      // 防止弹出输入编辑
      textareaElement.setAttribute('readonly', 'readonly')
      //将需要拷贝的内容设置到textarea元素中。
      textareaElement .value = this.codeUrl
      document.body.appendChild(textareaElement)
      //选中textarea元素，以备调用系统copy函数复制其中的内容。
      textareaElement.select()
      document.execCommand('copy')
      this.$NewMessageBox({
        title: 'Copy Link',
        message: 'The link has been copied to your clipboard',
        confirmBtn:'Done',
        btnType:'success'
      })
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 25px 15px 25px;
    .qrcode{
      display: flex;
      justify-content: center;
    }
    .info{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      .link{
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 10px;
      }
      .blue{
        color: #0366D6;
      }
    }
    .btn-list{
      margin-top: 20px;
      text-align: right;
      .red{
        color: #CB2431;
      }
    }
  }
}
</style>
